import { renderMap } from './renderMap';
import { renderText } from './renderText';
import { renderWeather } from './renderWeather';
import type { MixedData } from './types';

/**
 * Renders each declared component in order, dispatching to the same
 * renderers used for their standalone display types. An unrecognized
 * component `type` is skipped entirely — Gemini can only ever compose the
 * handful of components this switch knows about, never an arbitrary one.
 */
export function renderMixed(container: HTMLElement, data: MixedData | undefined): void {
  for (const component of data?.components ?? []) {
    switch (component.type) {
      case 'text':
        renderText(container, component.text);
        break;
      case 'map':
        renderMap(container, component.map);
        break;
      case 'weather':
        renderWeather(container, component.weather);
        break;
      default:
        break;
    }
  }
}
